import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import camelcaseKeys from "camelcase-keys";
import {
  onCreateBroadcast,
  onGetAddressToBroadcastMessage,
} from "services/apis/broadcast";
import snakecaseKeys from "snakecase-keys";

export const doCreateBroadcast = createAsyncThunk(
  "broadcast/doCreateBroadcast",
  async params => {
    const result = await onCreateBroadcast(snakecaseKeys(params));
    if (!result) {
      return;
    }
    return result;
  }
);

export const doGetListAddress = createAsyncThunk(
  "broadcast/doGetListAddress",
  async params => {
    const result = await onGetAddressToBroadcastMessage(snakecaseKeys(params));
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);
const initialState = {
  isLoading: false,
  list: [],
};

const slice = createSlice({
  name: "broadcast",
  initialState: initialState,
  extraReducers: {
    [doCreateBroadcast.pending]: state => {
      state.isLoading = true;
    },
    [doCreateBroadcast.rejected]: state => {
      state.isLoading = false;
    },
    [doCreateBroadcast.fulfilled]: state => {
      state.isLoading = true;
    },
    [doGetListAddress.pending]: state => {
      state.isLoading = true;
    },
    [doGetListAddress.rejected]: state => {
      state.isLoading = false;
    },
    [doGetListAddress.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.list = action.payload;
    },
  },
});

const { reducer } = slice;
export default reducer;

export const getIsLoading = createSelector(
  state => state.broadcast.isLoading,
  isLoading => isLoading
);

export const getListAddress = createSelector(
  state => state.broadcast.list,
  list => list
);
